import { ehSalaDeWhatsapp } from './janelaDoWhatsapp';

/**
 * O vocabulário do filtro de canal, numa casa só.
 *
 * Nasceu no Painel de Atendimentos (item 8, 02/10) declarado dentro da própria
 * tela. O item 6 pede o mesmo filtro na lista lateral do chat ao vivo -- e
 * copiar as três constantes e o predicado para lá seria repetir exatamente o
 * erro que este projeto já pagou: a regra de "esta conversa é de WhatsApp?"
 * morava em quatro lugares, um deles estava errado, e o resultado foi TODA
 * conversa de WhatsApp aparecer no painel como chat do site.
 *
 * Os valores são os mesmos de `Room::CANAL_*` na api, porque é a string crua
 * que viaja no parâmetro `canal` dos endpoints que contam.
 */
export const CANAL_TODOS = 'todos';
export const CANAL_WHATSAPP = 'whatsapp';
export const CANAL_SITE = 'site';

/** As opções na ordem em que aparecem no seletor, com o rótulo de cada uma. */
export const CANAIS = [
    { value: CANAL_TODOS, label: 'Todos os canais' },
    { value: CANAL_WHATSAPP, label: 'WhatsApp' },
    { value: CANAL_SITE, label: 'Chat do site' },
];

/**
 * A conversa passa no filtro de canal?
 *
 * A regra de canal não é reescrita aqui: quem responde é `ehSalaDeWhatsapp()`,
 * o mesmo predicado que escolhe o ícone de cada linha nas duas telas. Se o
 * filtro e o ícone pudessem discordar, a tela esconderia conversa que ela
 * própria desenha como sendo do canal escolhido.
 *
 * `CANAL_TODOS` -- e qualquer valor que não conheçamos -- não filtra nada: o
 * padrão das duas telas é mostrar os dois canais.
 */
export const passaNoCanal = (conversa, canal) => {
    if (canal !== CANAL_WHATSAPP && canal !== CANAL_SITE) return true;
    return ehSalaDeWhatsapp(conversa) === (canal === CANAL_WHATSAPP);
};
